function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable no-alert */
/* @pareto-engineering/generator-front 1.1.1-alpha.2 */
import * as React from 'react';
import PropTypes from 'prop-types';

// Local Definitions

import { FormInput, getFileType } from "../../../../../../f";
import { ExpandableLexicalPreview } from "../../../../..";
import styleNames from '@pareto-engineering/bem/exports';
const baseClassName = styleNames.base;
const componentClassName = 'section';
const fileTypeMapper = {
  VID: 'Video',
  TXT: 'Text',
  IMG: 'Image',
  PDF: 'PDF',
  AUD: 'Audio',
  FILE: 'Generic'
};

/**
 * This is the component description.
 */
const Section = ({
  id,
  className: userClassName,
  style,
  title,
  description,
  inputs,
  readOnly,
  fileUploadStatus,
  handleFileDelete,
  onFileUpload,
  sectionIndex
  // ...otherProps
}) => /*#__PURE__*/React.createElement("div", {
  id: id,
  className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
  style: style
}, /*#__PURE__*/React.createElement("p", {
  className: "h3"
}, title), /*#__PURE__*/React.createElement(ExpandableLexicalPreview, {
  nodes: description,
  name: "instructions"
}), inputs?.map((input, inputIndex) => {
  const isFileInput = input.type === 'file';
  return /*#__PURE__*/React.createElement(FormInput, _extends({
    key: input.name
  }, input, {
    disabled: readOnly
  }, isFileInput && {
    uploadStatus: fileUploadStatus,
    handleFileDelete,
    onChange: files => {
      const filesToUpload = files?.filter(file => file instanceof File).map(file => ({
        file,
        name: file.name,
        mimeType: file.type,
        type: fileTypeMapper[getFileType(file)] || 'Generic',
        title: file.name,
        sectionIndex,
        inputIndex
      }));
      onFileUpload(filesToUpload);
    }
  }));
}));
Section.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string)
};
Section.defaultProps = {
  // someProp:false
};
export default Section;